import { useState, useEffect } from 'react';
import { IEpisode } from '@packages/global';
import { episodeApi } from '../services/user/episode.api';

/**
 * 获取单个集的详情
 */
export const useEpisode = (episodeId?: string) => {
  const [episode, setEpisode] = useState<IEpisode | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!episodeId) {
      setLoading(false);
      return;
    }

    const fetchEpisode = async () => {
      try {
        setLoading(true);
        setError(null);
        const data = await episodeApi.getEpisode(episodeId);
        setEpisode(data);
      } catch (err) {
        setError(err instanceof Error ? err.message : '获取集详情失败');
      } finally {
        setLoading(false);
      }
    };

    fetchEpisode();
  }, [episodeId]);

  const refreshEpisode = async () => {
    if (!episodeId) return;
    
    try {
      const data = await episodeApi.getEpisode(episodeId);
      setEpisode(data);
    } catch (err) {
      console.error('刷新集详情失败:', err);
    }
  };

  return {
    episode,
    loading,
    error,
    refreshEpisode
  };
};
